import { IconProps } from './index';

const ArrowDownSLine: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M10 10.977l4.125-4.125 1.178 1.178L10 13.333 4.696 8.03l1.179-1.178L10 10.977z"
                fill="currentColor"
            />
        </svg>
    );
};

export default ArrowDownSLine;
